import React from 'react';

import messages from './messages';

import { DeleteOutlined } from '@ant-design/icons';
import { FormattedDate, FormattedMessage } from 'react-intl';
import Table from 'components/Table';
import Button from 'components/forms/Button';
import { Popconfirm } from 'antd';
const { Column } = Table;

const DisplayTable = ({ data = null, fetching = false, onClickDelete = null, rowSelection = null }) => (
    <Table
        loading={fetching}
        dataSource={data}
        pagination={{
            pageSize: 31,
            hideOnSinglePage: true,
        }}
        rowKey="id"
        tableLayout="auto"
        size="small"
        scroll={{ y: 500 }}
        rowSelection={rowSelection}
    >
        <Column title={<FormattedMessage {...messages.nameColumnLabel} />} dataIndex="name" />
        <Column
            title={<FormattedMessage {...messages.categoryColumnLabel} />}
            dataIndex="category"
            render={(value) => value.replace('_', ' ')}
        />
        <Column
            title={<FormattedMessage {...messages.startDateColumnLabel} />}
            dataIndex="startDateTime"
            render={(value) => (
                <FormattedDate value={value} weekday="short" day="2-digit" month="short" year="numeric" />
            )}
        />
        <Column
            title={<FormattedMessage {...messages.endDateColumnLabel} />}
            dataIndex="endDateTime"
            render={(value) => (
                <FormattedDate value={value} weekday="short" day="2-digit" month="short" year="numeric" />
            )}
        />
        <Column
            dataIndex="actions"
            width="10%"
            align="center"
            render={(_value, row) => (
                <>
                    <Popconfirm
                        title={<FormattedMessage {...messages.confirmDeletionText} />}
                        okText={<FormattedMessage {...messages.confirmOk} />}
                        cancelText={<FormattedMessage {...messages.confirmCancel} />}
                        onConfirm={() => onClickDelete(row.id)}
                    >
                        <Button name="deleteBtn" icon={<DeleteOutlined />} />
                    </Popconfirm>
                </>
            )}
        />
    </Table>
);

export default DisplayTable;
